import Box from '@carrier-io/air-react/Box';
import styles from '../styles/Dashboard.module.css';
import Stack from '@carrier-io/air-react/Stack';
import { Typography } from '@carrier-io/air-react';

export type StatBoxProps = {
  value: number;
  title: string;
  accumulation: string;
};

export function StatBox(props: StatBoxProps) {
  return (
    <Box data-testid="stat-box" className={styles.statsBox}>
      <Stack direction="column" alignItems="flex-start" width="200px">
        <Typography variant="h5" style={{ color: '#060F16' }}>
          {props.value}
        </Typography>
        <Typography variant="body1" style={{ color: '#060F16' }}>
          {props.title}
        </Typography>
        <Typography variant="caption" style={{ color: '#63676B' }}>
          {props.accumulation}
        </Typography>
      </Stack>
    </Box>
  );
}
